import axios from 'axios';

import get from 'lodash/get';

import ErrorHandler from 'store/utils/ErrorHandler';
import Notify from 'store/utils/Notify';
import request from 'store/utils/request';
import { getPaginationOptions } from 'store/services/dictionaries/selectors';
import { getDictionariesList } from 'store/services/dictionaries/actions';
import * as api from './api';
import * as types from './actionTypes';

/**
 * Upload CSV
 *
 * @param data
 */
export const uploadCSV = data => async dispatch => {
  try {
    await dispatch({
      type: types.UPLOAD_CSV_REQUEST,
    });

    const response = await api.uploadCSVRequest(data);

    await dispatch({
      type: types.UPLOAD_CSV_SUCCESS,
      payload: {
        csv: response.data,
      },
    });
  } catch (error) {
    if (axios.isCancel(error)) {
      Notify.success({
        title: 'Uploading CSV file was cancelled!',
      });
    }

    await dispatch({
      type: types.UPLOAD_CSV_ERROR,
      payload: {
        error: get(
          error,
          'response.data.non_field_errors',
          'Something went wrong while importing this CSV',
        ),
      },
    });

    throw error;
  }
};

/**
 * Cancel uploading a csv
 */
export const cancelUploadCSV = () => dispatch => {
  request.cancel('upload-csv');

  dispatch({
    type: types.CANCEL_UPLOAD_CSV,
  });
};

/**
 * Save a csv
 *
 * @param id
 */
export const saveCSV = id => async (dispatch, getState) => {
  try {
    dispatch({
      type: types.SAVE_CSV_REQUEST,
    });

    await api.saveCSVRequest(id);

    dispatch({
      type: types.SAVE_CSV_SUCCESS,
    });

    // Refresh dictionaries list to update count on the list]
    const paginationOptions = getPaginationOptions(getState());
    const dictionariesList = getDictionariesList(paginationOptions);
    await dispatch(dictionariesList);

    Notify.success({
      title: 'Entries were saved successfully!',
    });
  } catch (error) {
    if (axios.isCancel(error)) {
      Notify.success({
        title: 'Saving CSV file was cancelled!',
      });
    } else {
      Notify.error({
        title: 'Fail to save CSV file',
        description: ErrorHandler.getNotificationError(error),
      });
    }

    dispatch({
      type: types.SAVE_CSV_ERROR,
      payload: {
        error: error.message,
      },
    });

    throw error;
  }
};

/**
 * Cancel saving a csv
 */
export const cancelSaveCSV = () => dispatch => {
  request.cancel('save-csv');

  dispatch({
    type: types.CANCEL_SAVE_CSV,
  });
};

/**
 * Get a csv
 *
 * @param id
 */
export const getCSV = id => async dispatch => {
  try {
    await dispatch({
      type: types.GET_CSV_REQUEST,
    });

    await api.getCSVRequest(id);

    await dispatch({
      type: types.GET_CSV_SUCCESS,
    });
  } catch (error) {
    await dispatch({
      type: types.GET_CSV_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

export const clearCSV = () => ({
  type: types.CLEAR_CSV,
});
